module.exports = __webpack_public_path__ + "static/media/7_2.a042b426.png";